<template>
  <div class="container">
    <div class="content" :style="packUpHeight? 'max-height: 0px' : 'max-height: 19vw'" @click="to(info.order.id)">
      <div>
        <img :src="info.user.headImgUrl" class="avatar"/>
      </div>
      <div style="flex: 1;padding: 3vw 0">
        <div class="nameOrvoice">
          <div class="name">{{  info.user.nickname }}</div>
        </div>
        <div class="Pirce">
          {{ formatPrice(info.order.totalAmount) }}个
          *{{ info.order.num }}
          {{ info.order.item.names.join(' / ') }}
        </div>
      </div>
    </div>

    <div class="status" @click="to(info.order.id)">
      <div class="Progress" :style="`width: ${ 25 * (info.order.status? (info.order.status + 1) : 1) }%`"></div>
      <div class="ProgressALl"></div>
      <div v-for="(item, index) in statusList" class="statusItem" :key="index">
        <img :src="`/static/images/2184/chat/status${item.status == info.order.status? 'On' : 'Off'}.png`" class="statusImg"/>
        <div class="statusName">
          {{item.name}}
        </div>
      </div>
    </div>
    <div v-if="timeRemaining > 0 || info.order.status === 2" class="noOrPackup">
      <div class="bold-text">服务剩余时间: {{ formattedTimeRemaining }}</div>
    </div>
    <div class="noOrPackup">
      <div class="no">订单号 {{ info.order.no }}</div>
      <div class="copy" @click.stop="copy(info.order.no)"> 复制 </div>
      <div class="packUp" @click.stop="packUp">{{packUpHeight? '展开' : '收起'}}
        <img v-if="packUpHeight" style="margin-left: 8px;width: 2.3vw" src="/static/images/2184/chat/triangle-inverted.png">
        <img v-if="!packUpHeight" style="margin-left: 8px;width: 2.3vw" src="/static/images/2184/chat/triangle.png">
      </div>
    </div>
  </div>
</template>

<script>
import voice from "@/views/2184/clerk/chat/component/voice";
import {Toast} from "vant";
import Decimal from "decimal.js";
export default {
  name: "orderUI",

  components:{
    voice
  },
  computed: {
    formattedTimeRemaining() {
      const hours = Math.floor(this.timeRemaining / (1000 * 60 * 60));
      const minutes = Math.floor((this.timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((this.timeRemaining % (1000 * 60)) / 1000);
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    },
  },
  props:{
    info: Object,
    default(){
      return {}
    }
  },

  data(){
    return{
      audio: null,
      packUpHeight: false,
      statusList:[
        {
          name: '待接单',
          status: 0,
        },
        {
          name: '待服务',
          status: -1,
        },
        {
          name: '服务中',
          status: 2,
        },
        {
          name: '已完成',
          status: 3,
        },
      ],
      timeRemaining: 0, // 剩余时间（毫秒）
      interval: null, // 定时器
    }
  },

  methods:{
    to(id){
      this.$router.push({path:'/clerk/order/detail/'+ id});
    },
    formatAudioDuration(duration,company) {
      if (duration != null) {
        duration = Decimal.div(duration, 1000).toFixed(0)
        if (duration.length < 2) {
          duration = '0' + duration
        }
        if(company){
          return duration + company
        }else {
          return duration
        }
      }
      return ''
    },

    audioplay(){
      if( this.audio ){
        this.audio.pause()
        this.audio = null
        return
      } else {
        const audio = new Audio(this.info.clerk.audioUrl)
        this.audio = audio
        audio.play()
        audio.onended = () => {
          this.audio = null
        }
      }
    },

    packUp(){
      this.packUpHeight = !this.packUpHeight
    },

    copy(val){
      let input = document.createElement("input");
      input.value = val;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      Toast('复制成功');
    },

    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
    updateTimeRemaining() {
      const now = new Date();
      const expectedEndTime = new Date(this.info.order.expectedEndTime);
      this.timeRemaining = expectedEndTime - now;
    },
  },
  mounted() {
    this.updateTimeRemaining(); // 初始化时间
    this.interval = setInterval(this.updateTimeRemaining, 1000); // 每秒更新一次
  },
  beforeDestroy() {
    clearInterval(this.interval); // 清除定时器
  },
}
</script>

<style scoped lang="less">
.container{
  background: #fff;
  border-radius: 2.65vw;

  .content{
    display: flex;
    padding: 2.65vw 4.58vw 0vw 2.41vw;
    overflow: hidden;
    transition-duration: 500ms;

    .avatar{
      width: 16.18vw;
      height: 16.18vw;
      object-fit: cover;
      margin-right: 2.7vw;
      margin-top: 1.44vw;
      border-radius: 50%;
    }

    .nameOrvoice{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 1.20vw;
      margin-bottom: 2vw;

      .name{
        font-size: 3.7vw;
        color: #333333;
      }

      .audio{
        border-radius: 111px;
        background: linear-gradient(90deg, #398FF6, #8654FF);
        display: flex;
        align-items: center;
        padding: .7vw 3.6vw .7vw .7vw;

        .times{
          color: #fff;
          font-size: 3.14vw;
        }
      }
    }

    .intro{
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* 设置行数 */
      -webkit-box-orient: vertical;
      color: #808080;
      font-size: 3.38vw;
      line-height: 5.55vw;
    }

    .Pirce{
      font-weight: bold;
      margin-top: .88vw;
      font-size: 3.7vw;
      color: #333;
    }
  }

  .status{
    height: 7.00vw;
    position: relative;
    margin: 0 4.34vw 7.77vw;
    display: flex;

    &::after{
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      background: url("/static/images/154/Overlay.png");
      background-size: 100% 100%;
    }

    .statusItem{
      flex: 1;
      text-align: center;
      position: relative;

      .statusImg{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        height: 3.14vw;
        width: 3.14vw;
        z-index: 222;
      }

      .statusName{
        position: absolute;
        left: 50%;
        bottom: -3.62vw;
        transform: translateX(-50%);
        white-space: nowrap;
        font-size: 3.5vw;
        color: #808080;
      }
    }

    .ProgressALl{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      right: 0;
      height: 5px;
      background: #E6E6E6;
      border-radius: 222px;
    }

    .Progress{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      height: 5px;
      background: #B687FC;
      border-radius: 222px;
      z-index: 111;
    }
  }

  .noOrPackup{
    display: flex;
    align-items: center;
    font-size: 3.38vw;
    padding: 0 4.34vw 4.34vw;

    .no{
      color: #999999;
    }

    .copy{
      font-size: 2.65vw;
      color: #666;
      background: #F2F2F2;
      height: 3.62vw;
      line-height: 3.62vw;
      width: 7.72vw;
      text-align: center;
      border-radius: 1px;
      margin-left: 2px;
    }

    .packUp{
      margin-left: auto;
      display: flex;
      align-items: center;
      color: #333333;
    }
    .bold-text {
      font-weight: bold; /* 或者使用数值 700 */
    }
  }
}
</style>
